import {useSelector} from 'react-redux';
import {
  selectRegistries,
  selectRegistryName,
  selectRegistryNote,
  selectRegistryType,
  selectRegistryWording,
} from '~/common/fabric/reducers/registry/selectors';
import {Registry, RegistryVendor} from '~/ViewInvitation/common/RegistryVendor';
import {Header} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/components/Header/Header';
import {Step} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/Step';
import {Button} from '~library/atoms/Button';
import {Link} from '~library/atoms/Link';
import {Typography} from '~library/atoms/Typography';

import './RegistryWishlist.sass';

type RegistryWishlistProps = {
  onCloseClick: () => void;
  altTitle?: string;
};

export const RegistryWishlist = ({onCloseClick, altTitle}: RegistryWishlistProps) => {
  const wording = useSelector(selectRegistryWording);
  const registries: Registry[] = useSelector(selectRegistries);
  const registryName = useSelector(selectRegistryName);
  const registryType = useSelector(selectRegistryType);
  const registryNote = useSelector(selectRegistryNote);
  const nameBiggerThanNecessaryWords = registryName.split(' ').length > 5;
  const shortenedName =
    registryName.split(' ').slice(0, 6).join(' ').trim() +
    (nameBiggerThanNecessaryWords ? '...' : '');
  const title = `Get a gift from ${shortenedName}'s ${wording}`;

  return (
    <Step
      header={<Header onClose={onCloseClick} title={altTitle || title} />}
      title={altTitle ? title : undefined}
      description={`${shortenedName} has shared a ${wording} — start browsing now to find the perfect gift.`}
      contentClassName="rsvp__registy-wishlist"
      footer={
        <>
          <Button
            variant="secondary"
            size="large"
            data-qa-id="af-rsvp-registry-skip"
            onClick={onCloseClick}
            className="rsvp-step__footer__cta"
          >
            Maybe later
          </Button>
          <Link
            as="primary"
            data-impression-tracking="true"
            data-qa-id="af-rsvp-registry-btn"
            href={registries[0].url}
            target="_blank"
            className="rsvp-step__footer__cta"
          >
            {`View ${wording}`}
          </Link>
        </>
      }
    >
      <div className="registry-wishlist__vendors-and-note">
        <RegistryVendor
          type={registryType}
          registry={registries[0]}
          dataQaId="af-rsvp-registry-card"
          key={`${registries[0].id ?? registries[0].name}`}
        />

        {registryNote && (
          <Typography color="pebble" variant="paragraph3" classNames="registry-wishlist__note">
            &rdquo;{registryNote}&rdquo;
          </Typography>
        )}
      </div>
    </Step>
  );
};
